const councilManagement = {
  en: {
    councilManagementPage: {
      regions: {
        "Adamawa": "Adamawa", "Centre": "Centre", "East": "East", "Far North": "Far North", "Littoral": "Littoral",
        "North": "North", "North-West": "North-West", "South": "South", "South-West": "South-West", "West": "West"
      },
      statuses: { active: "active", inactive: "inactive" },
      toasts: {
        loadFailed: "Failed to load data",
        nameAbbrRequired: "Name and abbreviation are required",
        partyCreated: "Party created successfully",
        partyCreateFailed: "Failed to create party",
        aspirantFieldsRequired: "Name, party, and council are required",
        aspirantRegistered: "Mayor aspirant registered",
        aspirantFailed: "Failed to register aspirant"
      },
      accessDenied: "Access Denied",
      adminOnly: "Only administrators can access this page.",
      returnDashboard: "Return to Dashboard",
      title: "Council Elections Management",
      subtitle: "Manage parties, candidates, and election setup",
      tabs: {
        councils: "Councils ({{count}})",
        parties: "Parties ({{count}})",
        aspirants: "Aspirants ({{count}})",
        officers: "Officers"
      },
      councils: {
        title: "All {{count}} Councils of Cameroon",
        description: "Browse and manage council information",
        searchPlaceholder: "Search councils...",
        allRegions: "All Regions",
        loading: "Loading...",
        showing: "Showing {{shown}} of {{total}} councils",
        councilName: "Council Name",
        division: "Division",
        region: "Region",
        seats: "Seats",
        status: "Status",
        firstHundred: "Showing first 100 results. Use search to find specific councils."
      },
      parties: {
        title: "Political Parties",
        description: "Manage registered political parties",
        add: "Add Party",
        dialogTitle: "Add Political Party",
        name: "Party Name",
        abbreviation: "Abbreviation",
        color: "Party Color",
        descriptionOptional: "Description (Optional)",
        descriptionPlaceholder: "Brief description of the party",
        cancel: "Cancel",
        create: "Create Party",
        emptyTitle: "No parties registered yet",
        emptyHint: "Add political parties to get started"
      },
      aspirants: {
        title: "Mayor Aspirants",
        description: "Registered mayor candidates by party and council",
        register: "Register Aspirant",
        dialogTitle: "Register Mayor Aspirant",
        fullName: "Full Name",
        fullNamePlaceholder: "Enter aspirant's full name",
        party: "Political Party",
        selectParty: "Select party",
        council: "Council",
        selectCouncil: "Select council",
        firstFifty: "Showing first 50 councils. Search for specific council above.",
        bioOptional: "Bio (Optional)",
        bioPlaceholder: "Brief biography",
        cancel: "Cancel",
        emptyTitle: "No aspirants registered yet",
        emptyHint: "Register parties first, then add mayor aspirants",
        name: "Name",
        partyCol: "Party",
        councilCol: "Council",
        regionCol: "Region"
      },
      officers: {
        title: "Local Officers",
        description: "Manage officers assigned to input council results",
        soon: "Officer management coming soon",
        hint: "Assign users to specific councils for result input"
      }
    }
  },
  fr: {
    councilManagementPage: {
      regions: {
        "Adamawa": "Adamaoua", "Centre": "Centre", "East": "Est", "Far North": "Extrême-Nord", "Littoral": "Littoral",
        "North": "Nord", "North-West": "Nord-Ouest", "South": "Sud", "South-West": "Sud-Ouest", "West": "Ouest"
      },
      statuses: { active: "actif", inactive: "inactif" },
      toasts: {
        loadFailed: "Échec du chargement des données",
        nameAbbrRequired: "Le nom et le sigle sont obligatoires",
        partyCreated: "Parti créé avec succès",
        partyCreateFailed: "Échec de la création du parti",
        aspirantFieldsRequired: "Le nom, le parti et la commune sont obligatoires",
        aspirantRegistered: "Aspirant à la mairie enregistré",
        aspirantFailed: "Échec de l'enregistrement de l'aspirant"
      },
      accessDenied: "Accès refusé",
      adminOnly: "Seuls les administrateurs peuvent accéder à cette page.",
      returnDashboard: "Retour au tableau de bord",
      title: "Gestion des élections municipales",
      subtitle: "Gérez les partis, les candidats et la préparation des élections",
      tabs: {
        councils: "Communes ({{count}})",
        parties: "Partis ({{count}})",
        aspirants: "Aspirants ({{count}})",
        officers: "Agents"
      },
      councils: {
        title: "Les {{count}} communes du Cameroun",
        description: "Consultez et gérez les informations des communes",
        searchPlaceholder: "Rechercher des communes...",
        allRegions: "Toutes les régions",
        loading: "Chargement...",
        showing: "Affichage de {{shown}} sur {{total}} communes",
        councilName: "Nom de la commune",
        division: "Département",
        region: "Région",
        seats: "Sièges",
        status: "Statut",
        firstHundred: "Affichage des 100 premiers résultats. Utilisez la recherche pour trouver des communes précises."
      },
      parties: {
        title: "Partis politiques",
        description: "Gérez les partis politiques enregistrés",
        add: "Ajouter un parti",
        dialogTitle: "Ajouter un parti politique",
        name: "Nom du parti",
        abbreviation: "Sigle",
        color: "Couleur du parti",
        descriptionOptional: "Description (facultative)",
        descriptionPlaceholder: "Brève description du parti",
        cancel: "Annuler",
        create: "Créer le parti",
        emptyTitle: "Aucun parti enregistré pour le moment",
        emptyHint: "Ajoutez des partis politiques pour commencer"
      },
      aspirants: {
        title: "Aspirants à la mairie",
        description: "Candidats à la mairie enregistrés par parti et par commune",
        register: "Enregistrer un aspirant",
        dialogTitle: "Enregistrer un aspirant à la mairie",
        fullName: "Nom complet",
        fullNamePlaceholder: "Saisissez le nom complet de l'aspirant",
        party: "Parti politique",
        selectParty: "Sélectionner un parti",
        council: "Commune",
        selectCouncil: "Sélectionner une commune",
        firstFifty: "Affichage des 50 premières communes. Recherchez une commune précise ci-dessus.",
        bioOptional: "Biographie (facultative)",
        bioPlaceholder: "Brève biographie",
        cancel: "Annuler",
        emptyTitle: "Aucun aspirant enregistré pour le moment",
        emptyHint: "Enregistrez d'abord les partis, puis ajoutez les aspirants à la mairie",
        name: "Nom",
        partyCol: "Parti",
        councilCol: "Commune",
        regionCol: "Région"
      },
      officers: {
        title: "Agents locaux",
        description: "Gérez les agents chargés de saisir les résultats des communes",
        soon: "La gestion des agents sera bientôt disponible",
        hint: "Affectez des utilisateurs à des communes précises pour la saisie des résultats"
      }
    }
  }
};

export default councilManagement;
